import { getUserInvoices, Invoice } from '@/lib/api/settings';
import { useStanQuery } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';

export const useInvoices = () => {
    const { data, isLoading, error, refetch } = useStanQuery<Invoice[], Error>({
        queryKey: [QUERY_KEYS.USER_INVOICES],
        queryFn: getUserInvoices,
        staleTime: 5 * 60 * 1000, // 5 minutes
        meta: { error: { sentryMessage: '[USER-INVOICES] failed-to-fetch-user-invoices' } },
    });

    return { data, isLoading, error, refetch };
};
